import React from 'react'

import { Modal } from 'react-bootstrap'

export default class formDelete extends React.Component {

    render() {
        const { saveHandler, cancelHandler, showDelete, mode, konfirmHandler,Model} = this.props

        return (
            <div class="mb-10">

                <Modal show={showDelete} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{mode} !</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div class="mb-3">
                            <h5>Anda akan menghapus golongan darah {Model.code} ?</h5>
                        </div>

                        <div class="row">

                            <div class="col-2">
                            <button type="cancel" class="btn btn-warning" style={{width: 60}} onClick={cancelHandler}>Tidak</button>
                            </div>

                            <div class="col-2">
                            <button type="button" class="btn btn-primary" style={{width: 60}} onClick={konfirmHandler}>Ya</button>
                            </div>

                        </div>

                    </Modal.Body>
                    {/* <Modal.Footer>
                        <button type="cancel" class="btn btn-warning" onClick={cancelHandler}>Tidak</button>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Ya</button>
                    </Modal.Footer> */}
                </Modal>
            </div>
        )
    }
}